import { StoreCard } from '@cash-rewards/cr-ui-components';
import { clsxm } from '@cash-rewards/reactjs';

import useFavouriteStore from '@/modules/shop/hooks/useFavouriteStore';
import { useOfferAsterisk } from '@/modules/shop/hooks/useOfferAsterisk';
import { StoreModel } from '@/modules/shop/models/offerModels';

interface StoreCarouselCardProps {
  store: StoreModel;
  className: string;
}
const StoreCarouselCard = ({
  store,
  className,
  ...rest
}: StoreCarouselCardProps) => {
  const { isFavourite, updateFavouriteStore } = useFavouriteStore(
    store.merchantId,
    store
  );

  const { commissionString } = useOfferAsterisk(
    store.cashbackCapDescription,
    store.firstTierMinimumSpendString,
    store.clientCommissionString
  );

  return (
    <div className={clsxm('w-[256px] ', className)}>
      <StoreCard
        logoUrl={store.logoUrl}
        merchantName={store.name}
        onFavouriteToggle={updateFavouriteStore}
        commissionString={commissionString}
        href={`/store/${store.hyphenatedString}`}
        isFavourite={isFavourite}
        {...rest}
      ></StoreCard>
    </div>
  );
};

export default StoreCarouselCard;
